import React from 'react';
import Hotitemcard from './Hotitemcard';
import '../../styles/HotAccessories.css';

const Lifestyle = ({hotAccessoriesCover,hotAccessories}) => {
    console.log("LifeStyle",hotAccessoriesCover['lifeStyle']);
    console.log("Life Style data",hotAccessories['lifeStyle']);
    return (
        <>
        <div className="HotAccessories">
                <div>
                    <img src={hotAccessoriesCover['lifeStyle']} alt={`${'index'} offer`}></img>
                </div>    

                <div>
                  {
                      hotAccessories['lifeStyle'].map((item,index)=>{
                          return(
                              <Hotitemcard key={item.image} name={item.name} prize={item.price} image={item.image} index={index}></Hotitemcard>
                          )
                      })
                  }
                </div>

           </div>
        </>
    )
}


export default Lifestyle
